module.exports = __webpack_public_path__ + "img/Signature-Marketing.4a9ed7f1.png";